<template>
  <div>



  <div style="background-color:#eee;padding:10px 8px;font-size:0.85em;color:#333;border-bottom:1px solid #ddd;" v-if="!ldrTableOnly">
    <div class="row align-items-center">
    <div class="col-5">
        <div>Overview of changes between 2000 and 2020</div>
    </div>
    <div class="col-7 text-right" style="color:#666;font-size:0.9em;">

              <form id="ldrFormatForm" v-if="!ldrForceFormat">
                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="ldrFormatPercent" value="percent" v-model="ldrFormat">
                  <label class="form-check-label" for="ldrFormatPercent">Percent of total area</label>
                </div>
                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="ldrFormatKm2" value="km2" v-model="ldrFormat">
                  <label class="form-check-label" for="ldrFormatKm2">Square kilometers</label>
                </div>

                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="ldrFormatHa" value="ha" v-model="ldrFormat">
                  <label class="form-check-label" for="ldrFormatHa">Hectares</label>
                </div>
                
                </form>
            </div>
    </div>
  </div>
    
    <div style="background-color:#f5f5f5;padding:10px;font-size:0.85em;"  v-if="!ldrTableOnly">
      
  <div class="row">
    <div class="col text-left">
      <div style="padding:10px 0px;color:rgba(21, 176, 26, 1.0);font-weight:600;">Positive changes (improvements)</div>
    </div>
    <div class="col text-center">
      <div style="padding:10px 0px;color:#888;font-weight:600;">Neutral or no change</div>
    </div>
    <div class="col text-right">
      <div style="padding:10px 0px;color:rgba(229, 0, 0, 1.0);;font-weight:600;">Negative changes (degradations)</div>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <div class="progress" style="height:20px;">
          <div class="progress-bar" role="progressbar" v-bind:style="progressPositive"></div>
          <div class="progress-bar" role="progressbar" v-bind:style="progressNeutral"></div>
          <div class="progress-bar" role="progressbar" v-bind:style="progressNegative"></div>
        </div>

    </div>
  </div>

  <div class="row">
    <div class="col text-left">
      <div style="padding:10px 0px;color:rgba(21, 176, 26, 1.0);font-weight:600;">{{ ldrFormatter(ldr.summary.improved) }}</div>
    </div>
    <div class="col text-center">
      <div style="padding:10px 0px;color:#888;font-weight:600;">{{ ldrFormatter(ldr.summary.stable) }}</div>
    </div>
    <div class="col text-right">
      <div style="padding:10px 0px;color:rgba(229, 0, 0, 1.0);;font-weight:600;">{{ ldrFormatter(ldr.summary.degraded) }}</div>
    </div>
  </div>
</div>
  <div class="row">
      <div class="col">

      <p  v-if="!ldrTableOnly">
      The table below shows details of how much land cover changed from one particular type to another type. The changes in green are 
      considered to be improvements, whereas the changes in red are considered to be degradations.
      </p>

        <table class="table table-sm text-center" style="font-size:0.8em;background-color:#f5f5f5;">

          <tr>
            <th class="text-left align-middle" style="padding:10px 8px;background-color:#eee;border-top:none;">&nbsp;</th>
            <th class="align-middle" style="width:130px;background-color:#eee;border-top:none;font-weight:normal;" v-for="cl in ldr.classes">{{cl.label}}</th>
          </tr>
          <tr v-for="from in ldr.classes" >
            <td class="text-left align-middle" style="padding:10px 8px;color:#333;">From {{from.label}} to:</td>
            <td :class="ldrClass(from,to)" v-for="to in ldr.classes" v-html="ldrTrajectory(from,to)">
            </td>
          </tr>

      
          <tr>
            <td colspan="44" style="text-align:left;font-size:0.8em;color:#888;padding:4px 8px;">
              Source: ESA-CCI
            </td>
          </tr>
          


        </table>



        <div class="factsheet-caution-notice" v-if="warning!='no'">
          
          
            <p><strong><i class="bi bi-exclamation-circle" style="font-size:1.5em;float:left;margin-right:8px;"></i> Use with caution! The Land Degradation Neutrality analysis is experimental.</strong></p>
            <p>
            The Land Degradation Neutrality calculations shown above use an unsupervised  
            algorithm on a coarse global 
            dataset. The results are not checked or verified by an expert. Contact us if you would like to quantify other change trajectories, use higher  
            resolution data, or analyse changes over a different time period.
            </p>
          
          
        </div>



    </div>
      
  </div>
  </div>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'; 

export default {
    name: 'LandDegradationNeutrality',
    components: { },
    props: ['location', 'source', 'download', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded', 'label', 'sublabel', 'src', 'ldr', 'ldrForceFormat', 'ldrDisplay', 'warning'],
    data() {
        return {
            ldrFormat: this.ldrForceFormat ? this.ldrForceFormat : 'percent'
        }
    },
    mounted() {
    },
    watch: {
      location() {
      },
      background() {
      },
      loaded() {
      }
    },
    methods: {
      ldrTrajectory(from, to) {
        var key = ""+from["value"]+to["value"]
        var value = this.ldr["trajectories"][key]["area"]
        var score = this.ldr["trajectories"][key]["score"]
        if(value == 0) {
          return "&ndash;"
        } else {
          if(score != 0) {
            return this.ldrFormatter(value);
            //return "<strong>"+this.ldrFormatter(value)+"</strong>";
          } else {
            return this.ldrFormatter(value);
          }
        }
        
      },
      ldrFormatter(value) {
        if(this.ldrFormat == 'ha') {
          return (value/10000).toFixed(0)+" ha"
        } else if(this.ldrFormat == 'km2') {
          return (value/1000000).toFixed(1)+" km²"
        } else if(this.ldrFormat == 'percent') {
          const percent = 100 * (value/this.ldr["summary"]["total"])
          return percent.toFixed(2)+"%"
        } else {
          return value
        }

      },
      ldrClass(from, to) {
        /* Returns a classname for styling purposes: neutral|positive|negative */
        var key = ""+from["value"]+to["value"]
        var score = this.ldr["trajectories"][key]["score"]
        if(this.ldrTableOnly) {
          if(from == to) {
            return "align-middle ldn-nochange"
          } else {
            return "align-middle"
          }
        }

        if(score == 1) {
          return "align-middle ldn-positive ldn-strong"
        } else if (score == 2) {
          return "align-middle ldn-negative ldn-strong"
        } else {
          return "align-middle ldn-neutral"
        }
      },

    },
    computed: {
      ldrFormatComputed() {
        if(this.ldrForceFormat) {
          return this.ldrForceFormat
        }
      },
      ldrTableOnly() {
        if(this.ldrDisplay=='table') {
          return true;
        } else {
          return false;
        }
      },
      progressPositive() {
        var width = 100 * (this.ldr["summary"]["improved"] / this.ldr["summary"]["total"])
        return "border:1px solid #fff;background-color:rgba(21, 176, 26, 1.0);width:"+width.toFixed(2)+"%"
      },
      progressNeutral() {
        var width = 100 * (this.ldr["summary"]["stable"] / this.ldr["summary"]["total"])
        return "border-top:1px solid #fff;border-bottom:1px solid #fff;background-color:#ddd;width:"+width.toFixed(2)+"%"
      },
      progressNegative() {
        var width = 100 * (this.ldr["summary"]["degraded"] / this.ldr["summary"]["total"])
        return "border:1px solid #fff;background-color:rgba(229, 0, 0, 1.0);width:"+width.toFixed(2)+"%"
      },
    }
}
</script>
<style>
</style>

<style scoped>
td.ldn-negative {
  background-color:rgba(229, 0, 0, 0.1);
  color:rgba(229, 0, 0, 1.0);
}
td.ldn-positive {
  background-color:rgba(21, 176, 26, 0.1);
  color:rgba(21, 176, 26, 1.0);
}
td.ldn-neutral {
  //background-color:rgba(250, 238, 102, 0.1);
}
td.ldn-strong {
  font-weight:bold;
}
td.ldn-nochange {
  background-color:#fff;
}
h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:rgb(33, 37, 41);
  font-weight:600;
  padding:12px 0px 8px 0px;
  margin:0px;

}
figcaption {
  font-size:0.75em;
  color:rgb(33, 37, 41);
  padding:8px 8px 8px 8px;
  border-bottom:1px dashed #ccc;
}
figure {
  background-color:#f5f5f5;
  //border: 1px solid #ddd;
}
div.image-wrapper {
  padding:8px;
}
div.attribution {
  font-size:0.55em;
  color:#666;
  padding:4px 8px 4px 8px;
}
p {
  margin:8px 0px;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  
}
div.map-wrap {
 background-color:#f5f5f5; 
 border-top:1px solid #ddd;
 border-bottom:1px solid #ddd;
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}
div.layer-commands {
  margin-top:3px;
  font-size:1em;
}
div.layer-commands a.btn-layer {
  color:#aaa;
}
div.layer-commands a.btn-layer:hover {
  color:#0056b3;
}
.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}
</style>